<a
  class="report-card"
  routerLink="{{ routerLink }}"
  id="{{ id }}">
  <h6 class="link-text">{{ cardTitle }}</h6>
  <p>{{ cardDescription }}</p>
</a>
